var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const self_1 = require("./self");
const button_reset_1 = require("./button-reset");
exports.Button = react_1.default.forwardRef((props, ref) => {
    const extraAttrs = {
        'aria-controls': props.ariaControls,
        'aria-expanded': props.ariaExpanded,
        'aria-label': props.ariaLabel,
        'aria-pressed': props.ariaPressed,
        disabled: props.disabled,
        onClick: props.onClick,
        role: props.role,
        type: props.type,
    };
    extraAttrs.ref = ref;
    extraAttrs.value = props.value;
    return self_1.getSelf(props, button_reset_1.buttonReset, 'button', extraAttrs);
});
//# sourceMappingURL=button.js.map